<script lang="ts">
    import type { Route } from "../Model/Route";

    export let route: Route = null;

</script>
<style lang="scss">

    .route-start-end {
        display: flex;
    }

    .square {
        $size: 2.5rem;
        width: $size;
        height: $size;
        line-height: $size;
        text-align: center;
        background-color: var(--route-color, --color-primary);
        color: #fff;
        border-radius: 3px;
        font-weight: bold;
    }

    .names {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .name {
        padding: 0 0.3rem;
        font-size: 0.7rem;
        color: var(--color-secondary);
    }

    .end-name {
        border-top: 3px solid var(--route-color, --color-primary);
        text-align: right;
    }

</style>

{#if route}
<div class="route-start-end">
    <div class="square">{route.firstCheckpoint.id}</div>
    <div class="names">
        <div class="name start-name">{route.firstCheckpoint.name}</div>
        <div class="name end-name">{route.lastCheckpoint.name}</div>
    </div>
    <div class="square">{route.lastCheckpoint.id}</div>
</div>
{/if}